<div class="flex flex-column w-full">
  <p-slider class="my-3" [step]="step" [max]="max" [min]="min"></p-slider>
  <div class="flex justify-content-between" dir="ltr">
    <div class="text-light">{{ min | amount }}</div>
    <div class="text-light">₪{{ max | amount }}</div>
  </div>
</div>
